<div class="reports">
  <div class="reports__export-buttons">
    <button mat-button (click)="downloadAsPDF()">Export to PDF</button>
    <button mat-button (click)="downloadAsCSV()">Export to CSV</button>
  </div>
  <h2>Reports</h2>
  <div class="reports__filters">
    <form [formGroup]="reportsFilters" class="reports__form">
      <div class="reports__container">
        <div class="reports__row">
          <div class="reports__column">
            <div class="time-entry-input__field time-entry-input__field--tags">
              <select-list #selectListProjects [optionList]="optionsFromProjects" [multiple]="true" [searchBar]="true" label="Projects" icon="folder" (selectedOptionsChanged)="reportsFilters.get('projects')?.setValue($event)" />
            </div>
          </div>
          <div class="reports__column">
            <select-list #selectListClients [optionList]="optionsFromClients" [multiple]="true" [searchBar]="true" label="Clients" icon="business" (selectedOptionsChanged)="reportsFilters.get('clients')?.setValue($event)" />
          </div>
          <div class="reports__column">
            <select-list #selectListTags [optionList]="optionsFromTags" [multiple]="true" [searchBar]="true" label="Tags" icon="label" (selectedOptionsChanged)="reportsFilters.get('tags')?.setValue($event)" />
          </div>
          <div class="reports__column">
            <select-list #selectListMembers [optionList]="optionsFromMembers" [multiple]="true" [searchBar]="true" label="Members" icon="person" (selectedOptionsChanged)="reportsFilters.get('users')?.setValue($event)" />
          </div>
        </div>
      </div>
    </form>
  </div>
  <mat-tab-group (selectedTabChange)="tabChange()">
    <mat-tab label="Summary">
      <app-reports-summary [projects]="projects" [timeTracks]="timeTracks" [users]="users"></app-reports-summary>
    </mat-tab>
    <mat-tab label="Detailed">
      <app-reports-detailed [timeTracks]="timeTracks" [projects]="projects" [tags]="tags"
        [users]="users"></app-reports-detailed>
    </mat-tab>
    <mat-tab label="Weekly">
      <app-reports-weekly [timeTracks]="timeTracks"></app-reports-weekly>
    </mat-tab>
  </mat-tab-group>
</div>
